import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=c4138338&scoped=true"
import script from "./profile.vue?vue&type=script&lang=js"
export * from "./profile.vue?vue&type=script&lang=js"
import style0 from "./profile.vue?vue&type=style&index=0&id=c4138338&prod&scoped=true&lang=scss"
import style1 from "./profile.vue?vue&type=style&index=1&id=c4138338&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4138338",
  null
  
)

export default component.exports